var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaptismCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8769 4.58447C30.8769 3.4799 29.9814 2.58447 28.8769 2.58447H8.26958C7.73416 2.58447 7.30011 3.01852 7.30011 3.55395C7.30011 4.08937 7.73416 4.52342 8.26958 4.52342H26.481C27.5855 4.52342 28.481 5.41885 28.481 6.52342V25.807C28.481 26.4686 29.0173 27.0049 29.6789 27.0049C30.3405 27.0049 30.8769 26.4686 30.8769 25.807V4.58447Z",
    fill: "url(#paint0_linear_4402_12114)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 18.8951C10.8689 19.0798 11.2948 18.8645 11.4497 18.4822C11.6137 18.0775 11.425 17.6158 11.0244 17.4419L10.5285 17.2266C9.94792 16.9745 9.24313 17.3247 9.4897 17.9076C9.66184 18.3145 10.0039 18.6466 10.5001 18.8951Z",
    fill: "url(#paint1_linear_4402_12114)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 16.9213C15.5541 16.9213 16.2745 16.3383 16.2745 15.6191C16.2745 14.8999 15.5541 14.3169 14.6654 14.3169C13.7767 14.3169 13.0563 14.8999 13.0563 15.6191C13.0563 16.3383 13.7767 16.9213 14.6654 16.9213Z",
    fill: "url(#paint2_linear_4402_12114)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1306 19.4277C15.8994 18.8572 15.281 18.562 14.6654 18.562C14.0499 18.562 13.4314 18.8572 13.2002 19.4277L13.0547 19.7869C12.6059 20.8942 13.4208 22.1037 14.6155 22.1037H14.7153C15.9101 22.1037 16.7249 20.8942 16.2762 19.7869L16.1306 19.4277Z",
    fill: "url(#paint3_linear_4402_12114)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8809 18.4822C18.0359 18.8645 18.4618 19.0799 18.8306 18.8951C19.3268 18.6466 19.6688 18.3145 19.8409 17.9076C20.0874 17.3247 19.3826 16.9745 18.8021 17.2266L18.3062 17.4419C17.9057 17.6158 17.7169 18.0775 17.8809 18.4822Z",
    fill: "url(#paint4_linear_4402_12114)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4538 8.16406C26.4538 7.05949 25.5584 6.16406 24.4538 6.16406H4.87695C3.77238 6.16406 2.87695 7.05949 2.87695 8.16406V28.5845C2.87695 29.6891 3.77238 30.5845 4.87695 30.5845H24.4538C25.5584 30.5845 26.4538 29.6891 26.4538 28.5845V8.16406ZM18.5831 10.0529C19.0825 10.3353 19.0838 11.0181 18.6378 11.3791C18.307 11.6468 17.8377 11.6388 17.4697 11.4252C15.8 10.4563 13.5307 10.4563 11.861 11.4252C11.4929 11.6388 11.0237 11.6468 10.6928 11.3791C10.2469 11.0181 10.2482 10.3353 10.7475 10.0529C13.0911 8.7273 16.2395 8.72727 18.5831 10.0529ZM8.29146 15.0997C8.61582 14.8101 9.08066 14.7362 9.47953 14.9094C10.2153 15.2289 11.1068 14.6584 11.606 14.0305C12.2533 13.2164 13.3827 12.6761 14.6653 12.6761C15.948 12.6761 17.0773 13.2164 17.7246 14.0305C18.2239 14.6584 19.1153 15.2289 19.8511 14.9094C20.25 14.7362 20.7148 14.81 21.0392 15.0996C21.9505 15.9131 22.2465 17.2864 21.759 18.4389C21.5554 18.9203 21.098 19.6307 20.0857 20.1912C19.4304 20.554 19.0315 21.3213 19.3128 22.0154C19.6477 22.8417 19.0397 23.7442 18.1481 23.7442H11.1826C10.291 23.7442 9.68296 22.8417 10.0178 22.0154C10.2992 21.3213 9.90025 20.554 9.24501 20.1912C8.23271 19.6307 7.77534 18.9203 7.57178 18.4389C7.08429 17.2864 7.38027 15.9133 8.29146 15.0997ZM8.8935 27.5519C8.44046 27.5519 8.07319 27.1846 8.07319 26.7315C8.07319 26.2785 8.44045 25.9112 8.8935 25.9112H20.4373C20.8903 25.9112 21.2576 26.2785 21.2576 26.7315C21.2576 27.1846 20.8903 27.5519 20.4373 27.5519H8.8935Z",
    fill: "url(#paint5_linear_4402_12114)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_12114",
    x1: 19.0885,
    y1: 2.58447,
    x2: 19.0885,
    y2: 27.0049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75E89D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_12114",
    x1: 10.5537,
    y1: 16.7583,
    x2: 10.5537,
    y2: 19.1551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75E89D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_12114",
    x1: 14.6654,
    y1: 14.3169,
    x2: 14.6654,
    y2: 16.9213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75E89D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4402_12114",
    x1: 14.6654,
    y1: 18.4336,
    x2: 14.6654,
    y2: 22.1037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75E89D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4402_12114",
    x1: 18.7769,
    y1: 16.7583,
    x2: 18.7769,
    y2: 19.1551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75E89D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4402_12114",
    x1: 14.6654,
    y1: 6.16406,
    x2: 14.6654,
    y2: 30.5845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75E89D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaptismCertificate);
export default __webpack_public_path__ + "static/media/Baptism Certificate.eba08070bee96c59df81a1088bb07c69.svg";
export { ForwardRef as ReactComponent };